// #region imports

// --- HS Code
import { JournalCategoryModel } from "./journal-category-model";

// #endregion

export interface JournalQuadrantModel {
  id: number;
  name: string;
  categoryModels: JournalCategoryModel[];
}
